import { TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import clsx from "clsx";

import useStyles from "./styles";

const CeroInput = (props) => {
    const classes = useStyles();
    return (
        <Box className={clsx(classes.container, props.classes?.container)} >
            {props.inputLabel&&<Typography className={classes.inputLabel}>{props.inputLabel}</Typography>}
            <TextField
                id={props.id}
                name={props.name}
                label={props.label}
                variant={props.variant || "outlined"}
                value={props.value}
                rows={props.rows || 1}
                required={!!props.required}
                multiline={props.multiline}
                size={props.size || "medium"}
                disabled={!!props.disabled}
                readOnly={props.readOnly} 
                error={!!props.error}
                placeholder={props.placeholder}
                onChange={props.onChange}
                onBlur={props.onBlur}
                className={clsx(classes.input, props.classes?.input)}
                type={props.type || "text"}
                helperText={props.helperText}
                InputProps={{...props.inputProps, endAdornment: props.endAdornment}}
            />
            {!!props.error && <Typography className={clsx(classes.text, classes.error, props.classes?.error)} >{props.error}</Typography>}
        </Box>
    );
};

export default CeroInput;
